import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { EDashboardTab } from 'src/types'
import { useAccount, useMe } from 'src/hooks'

import { AccountWelcome } from '../welcome'
import { AccountDashboard } from '../dashboard'
import { TabToggle } from './tab-toggle'

import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { Loader } from '../loader'

interface IProps {
  tab: EDashboardTab
}

export const DashboardSection = ({ tab: initialTab }: IProps) => {
  const { data: me, isLoading: meLoading } = useMe()
  const { data: account, isLoading: accountLoading } = useAccount()
  const [tab, setTab] = useState(initialTab)
  const navigate = useNavigate()
  const { accountId } = useParams()

  const handleTab = (tab: EDashboardTab) => {
    setTab(tab)

    if (tab === EDashboardTab.Welcome) {
      navigate(joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.DASHBOARD_WELCOME))
      return
    }
  }
  useEffect(() => {
    if (!me || !account) return

    if (me.show_welcome) {
      setTab(EDashboardTab.Welcome)
      return
    }
  }, [me, account])

  if (meLoading || accountLoading) {
    return <Loader />
  }

  if (!account) return null

  return (
    <div>
      <TabToggle handleTab={handleTab} tab={tab} me={me} account={account} setTab={setTab} />
      {tab === EDashboardTab.Welcome ? <AccountWelcome /> : <AccountDashboard />}
    </div>
  )
}
